import { render } from "./ScoreQuery.vue?vue&type=template&id=39cd2cb1&scoped=true"
import script from "./ScoreQuery.vue?vue&type=script&lang=js"
export * from "./ScoreQuery.vue?vue&type=script&lang=js"

import "./ScoreQuery.vue?vue&type=style&index=0&id=39cd2cb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cd2cb1"]])

export default __exports__